/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataCto } from '../../models/demo-account-data-cto';

export interface GetDemoAccountDataAsync$Plain$Params {
  demoDataType: ClassificationType;
}

export function getDemoAccountDataAsync$Plain(http: HttpClient, rootUrl: string, params: GetDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
  const rb = new RequestBuilder(rootUrl, getDemoAccountDataAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoAccountDataCto>;
    })
  );
}

getDemoAccountDataAsync$Plain.PATH = '/demo-account-data/{demoDataType}';
